import React, { createContext, useContext, useState, useEffect } from 'react';
import ConvertSDK from '@convertcom/js-sdk';
import configData from '../config.json';

const ConvertContext = createContext(null);

export const ConvertProvider = ({ children }) => {
  const [convertContext, setConvertContext] = useState(null);
  const [isReady, setIsReady] = useState(false);

  const sdk = new ConvertSDK({
    sdkKey: configData['AirswiftDigitalConvertSDK:SdkKey'],
    environment: 'production',
});

  useEffect( () => {
    const handleSdk = async () => {
        await sdk.onReady();
        await setConvertContext(sdk.data.experiences);
        await setIsReady(true);
    }

    handleSdk();
  }, []);

  return (
    <ConvertContext.Provider value={{ convertContext, isReady }}>
      {children}
    </ConvertContext.Provider>
  );
};

export const useConvert = () => useContext(ConvertContext);
